import { useEffect, useState } from 'react';
import { Globe, MessageCircle, X } from 'lucide-react';
import { round2 } from '../lib/api';

const DISMISS_KEY = 'mandispot_domain_banner_dismissed';

export default function LiveDomainBanner() {
  const [info, setInfo] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === '1');

  useEffect(() => {
    if (hidden) return;
    round2.domainStatus().then(setInfo).catch(() => {});
  }, [hidden]);

  if (hidden || !info?.live) return null;

  const text = `We're now live at ${info.domain}! Order from your local shops: ${info.url}\nअब हम ${info.domain} पर हैं! अपनी नज़दीकी दुकानों से ऑर्डर करें: ${info.url}`;
  const dismiss = () => { localStorage.setItem(DISMISS_KEY, '1'); setHidden(true); };

  return (
    <div data-testid="live-domain-banner" className="bg-[#1B5E20] text-white animate-in fade-in slide-in-from-top-2 duration-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2 flex items-center gap-3 text-sm">
        <Globe className="w-4 h-4 shrink-0"/>
        <span className="flex-1 min-w-0">
          <b>Now live at <a data-testid="live-domain-link" href={info.url} className="underline underline-offset-2">{info.domain}</a></b>
          <span className="hidden sm:inline"> · अब हम {info.domain} पर हैं!</span>
        </span>
        <a data-testid="live-domain-share-btn" href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-1.5 rounded-full bg-[#25D366] hover:bg-[#128C7E] px-3 py-1 text-xs font-bold transition-colors">
          <MessageCircle className="w-3.5 h-3.5"/>Share
        </a>
        <button data-testid="live-domain-dismiss-btn" onClick={dismiss} aria-label="Dismiss" className="p-1 rounded-full hover:bg-white/15 transition-colors">
          <X className="w-4 h-4"/>
        </button>
      </div>
    </div>
  );
}
